
/* eslint-disable @typescript-eslint/no-shadow */
export namespace SurveyTheme {
  export enum SurveyTheme {
    LILAC_SERENADE = "LILAC_SERENADE",
    SUMMER_SUNSET = "SUMMER_SUNSET",
    WINTER_MIDNIGHT = "WINTER_MIDNIGHT",
    AUTUMN_HARVEST = "AUTUMN_HARVEST",
    SPRING_BLOSSOM = "SPRING_BLOSSOM",
    CRIMSON_FALL = "CRIMSON_FALL",
    ARCTIC_MONOCHROME = "ARCTIC_MONOCHROME",
  }

  export interface SurveyThemeDTO {
    case: string;
  }

  export const fromDTO = (dto: SurveyThemeDTO): SurveyTheme => {
    if (dto === undefined || dto === null) {
      throw new InvalidSurveyThemeError(
        `Invalid DTO ${dto} provided for SurveyTheme.SurveyTheme`
      );
    }
    switch (dto.case) {
      case "LILAC_SERENADE":
        return SurveyTheme.LILAC_SERENADE;
      case "SUMMER_SUNSET":
        return SurveyTheme.SUMMER_SUNSET;
      case "WINTER_MIDNIGHT":
        return SurveyTheme.WINTER_MIDNIGHT;
      case "AUTUMN_HARVEST":
        return SurveyTheme.AUTUMN_HARVEST;
      case "SPRING_BLOSSOM":
        return SurveyTheme.SPRING_BLOSSOM;
      case "CRIMSON_FALL":
        return SurveyTheme.CRIMSON_FALL;
      case "ARCTIC_MONOCHROME":
        return SurveyTheme.ARCTIC_MONOCHROME;
      default:
        throw new InvalidSurveyThemeError(
          `Case ${dto.case} is not valid case of SurveyTheme.SurveyTheme`
        );
    }
  };

  export const toDTO = (surveyTheme: SurveyTheme): SurveyThemeDTO => {
    const enumDTO = {
      case: SurveyTheme[surveyTheme],
    };
    return enumDTO;
  };
}

export class InvalidSurveyThemeError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyThemeError";
  }
}
export class InvalidSurveyThemeLilacSerenadeError extends InvalidSurveyThemeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyThemeLilacSerenadeError";
  }
}

export class InvalidSurveyThemeSummerSunsetError extends InvalidSurveyThemeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyThemeSummerSunsetError";
  }
}

export class InvalidSurveyThemeWinterMidnightError extends InvalidSurveyThemeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyThemeWinterMidnightError";
  }
}

export class InvalidSurveyThemeAutumnHarvestError extends InvalidSurveyThemeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyThemeAutumnHarvestError";
  }
}

export class InvalidSurveyThemeSpringBlossomError extends InvalidSurveyThemeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyThemeSpringBlossomError";
  }
}

export class InvalidSurveyThemeCrimsonFallError extends InvalidSurveyThemeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyThemeCrimsonFallError";
  }
}

export class InvalidSurveyThemeArcticMonochromeError extends InvalidSurveyThemeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyThemeArcticMonochromeError";
  }
}
